import type { DisruptionState } from "@b2bportal/core-disruption";
import type { CfarOffersState } from "@b2bportal/core-flights-cfar-offers";
import type { IApiConfig } from "@hopper-b2b/types";
import type { IFlightBookState } from "../modules/book/reducer";
import type { IFlightCfarState } from "../modules/cfar/reducer";
import type { IFlightChfarState } from "../modules/chfar/reducer";
import type { IFlightDisruptionState } from "../modules/disruption/reducer";
import type { IFlightExchangeState } from "../modules/exchange/reducer";
import type { IFlightFreezeState } from "../modules/freeze/reducer";
import type { IFlightRewardsState } from "../modules/rewards/reducer";
import type { IFlightSearchState } from "../modules/search/reducer";
import type { IFlightShopState } from "../modules/shop/reducer";
import type { IFlightWalletState } from "../modules/wallet/reducer";

export const RESET_STATE = "RESET_STATE";
export type RESET_STATE = typeof RESET_STATE;

export const flightApiConfigStoreKey = "flightApiConfig";

export interface IStoreState
  // State for disruption product from core-disruption
  extends DisruptionState {
  flightSearch: IFlightSearchState;
  flightShop: IFlightShopState;
  flightBook: IFlightBookState;
  flightRewards: IFlightRewardsState;
  flightFreeze: IFlightFreezeState;
  flightDisruption: IFlightDisruptionState;
  flightCfar: IFlightCfarState;
  flightApiConfig: IApiConfig;
  flightChfar: IFlightChfarState;
  flightExchange: IFlightExchangeState;
  flightWallet: IFlightWalletState;
  flightsCfarOffers: CfarOffersState;
}

export { FlightShopStep } from "../modules/shop/reducer";
